export const enLocalisation = {
  units: {
    hour: 'hour',
    hour_other: 'hours',
    day: 'day',
    day_other: 'days',
    week: 'week',
    week_other: 'weeks',
    month: 'month',
    month_other: 'months',
    year: 'year',
    year_other: 'years',
  },
  common: {
    address: 'Address',
    send: 'Send',
    back: 'Back ',
    password: 'Password',
    continue: 'Continue',
    enterTokenName: 'Enter token name',
    understood: 'Understood',
    save: 'Save',
    update: 'Update',
    cancel: 'Cancel',
    principalId: 'Principal ID',
    accountId: 'Account ID',
    swap: 'Swap',
    convert: 'Convert',
    mint: 'Mint',
    approve: 'Approve',
    confirm: 'Confirm',
    add: 'Add',
    bridge: 'Bridge',
    errors: {
      gasError: 'Could not calculate gas fee',
    },
  },
  convert: {
    enterAddress: "Enter the recepient's {{currency}} address",
    errors: {
      noAddress: 'Please enter {{currency}} address',
      addressInvalid: 'Please enter valid {{currency}} address',
    },
    exchangeId: 'Exchange ID:',
    youSend: 'You Send:',
    youReceive: 'You Receive:',
    recepientsAddress: "Recipient's address:",
    toAddress: 'To address:',
    depositTimeCaption:
      'Deposit approval can take a while, you can always check convert status in the Activity section',
    statuses: {
      waiting: 'Awaiting deposit',
      exchanging: 'Exchanging',
      sending: 'Sending to your wallet',
      confirming: 'Confirming',
      finished: 'Finished',
      failed: 'Failed',
      refunded: 'Your deposit has been refunded',
      verifying: 'Verifying',
    },
    support: 'Contact Support',
    startConversion: 'Start Conversion',
  },
  welcome: {
    title: 'Plug into the Internet Computer Ecosystem',
    description:
      'You can import an existing wallet, create a new wallet, or use a seed phrase to restore a wallet',
    create: 'Create wallet',
    import: 'Import wallet',
  },
  passwordSetup: {
    title: 'Create your password',
    description: 'Choose a password to secure & lock your wallet',
    set: 'Set password',
    password: 'Password (min 8 characters)',
    repeatPassword: 'Repeat password',
    passwordError: 'Password has to be at least 8 characters long',
    repeatedPasswordError: 'Repeated password has to be equal to password',
  },
  walletSuccess: {
    title: 'Wallet Created Successfully',
    description: 'Click Plug from Extension drop-down to access your wallet',
  },
  topbar: {
    settings: 'Settings',
    qr: 'My QR',
    contacts: 'Contacts',
    lock: 'Lock',
    help: 'Help',
    documentation: 'Documentation',
    support: 'Support',
  },
  manageTokens: {
    title: 'Manage Tokens',
    sections: {
      essential: 'Essential',
      custom: 'Custom',
      sns: 'SNSs',
      other: 'Other Tokens',
      'chain-fusion': 'Chain Fusion',
    },
    addCustom: 'Add custom token',
  },
  contacts: {
    addNew: 'Add New',
  },
  nft: {
    openAsset: 'Open Asset',
    sendNft: 'Send',
    noInfo: 'No information available',
    about: 'About',
    collection: 'Collection',
    info: 'Information',
    rarity: 'Rarity',
    number: 'Number',
    inscribed: 'Inscribed',
    standard: 'Standard',
    value: 'Value',
  },
  send: {
    title: 'Send',
    canisterTopup: 'Top-Up Canister',
    errors: {
      lowBalance: 'Not enough {{token}}',
      notEnoughForFee: 'Not enough {{token}} for TX fee',
      noAmount: 'Please enter amount',
      tooSmall: 'Amount is smaller than {{amount}}',
      xtcNoMode: 'Please select XTC send mode',
      notEnoughSolForRent:
        "You have to either fully deduct your SOL balance or leave at least {{rentFee}} SOL to cover your account's rent cost",
      ownWallet: "Can't send to your own wallet",
      noOrdinals: "Couldn't fetch ordinals",
      calculatingFee: 'Calculating fee',
    },
    contacts: {
      contacts: 'Contacts',
      wallets: 'Your other wallets',
      canisters: 'Saved Canisters',
    },
    noTokens: "Don't see token you're looking for?",
    findTokens: 'Try balance sync',
    to: 'To',
    firstTimeSend: 'First time sending to this address ⚠️',
    excludedOrdinals: 'All ordinals are excluded: {{ordinals}} ',
    selectedOrdinal: 'Selected ordinal',
    inputs: 'Inputs',
    addressField: {
      send: {
        title: 'To',
        placeholder: 'Principal, Account or Contact',
      },
      cycleTopup: {
        title: 'To',
        placeholder: 'Canister Address',
      },
    },
    review: {
      title: 'Review {{action}}',
      sendSuccess: 'Sent Succesfully',
      topupSuccess: 'Topped-Up Succesfully',
    },
    canisterReceives: 'Canister receives:',
    fee: 'Fee',
  },
  tokens: {
    sections: {
      all: 'All',
      sns: 'SNSs',
      essential: 'Essential',
      popular: 'Popular',
      eth: 'ETH',
      sol: 'SOL',
    },
    unavailableAnalytics: 'Analytics for this token are not available',
  },
  swap: {
    title: 'Swap',
    reviewSwap: 'Review Swap',
    success: 'Swapped Successfully',
    fallback: "Haven't received tokens? Try fallback",
    provider: 'Provider',
    price: 'Price',
    config: 'Swap Config',
    slippage: 'Slippage',
    kongFallback: 'Failed swaps on KongSwap are refunded automatically',
    balance: 'Balance',
    errors: {
      no_amount: 'Please enter amount',
      no_quote: 'Fetching Price',
      less_than_minimal: 'Amount less than minimal',
      not_enough_token: 'Not enough {{token}}',
      not_enough_token_for_fee: 'Not enough {{token}} to cover transaction fee',
      pairUnavailable: 'Swap pair unavailable',
      no_pair: 'Pair not found',
      searching_pairs: 'Searching pairs',
      no_token: 'Please select token',
      loading_price: 'Loading price',
      slippageTooHigh: 'Too high (Significant loss)',
    },
    steps: {
      undefined: 'Initializing',
      transfer: 'Transfering tokens',
      approve: 'Approving tokens',
      deposit: 'Depositing to pool',
      swap: 'Performing swap',
      withdraw: 'Withdrawing funds',
      errorFallback: 'Error - falling back',
    },
    searchPair: 'Search Swap Pair',
    fallbackICPSwap: 'Still no luck? Try Reclaim on ICPSwap directly',
  },
  swapDetails: {
    valueUSD: 'Amount in USD',
    slippage: 'Slippage',
    price: 'Price',
    earnings: 'Total Earnings',
    exchangeRate: 'Exchage Rate',
  },
  settings: {
    seedPhrase: {
      primaryText: 'Reveal Seed Phrase',
      secondaryText: 'View your secret recovery phrase',
    },
    dapps: {
      primaryText: 'Connected dApps',
      secondaryText: 'Manage dApps wallet is connected to',
    },
    pem: {
      primaryText: 'Export PEM',
      secondaryText: 'Export your private PEM key',
    },
    testnet: {
      primaryText: 'Developer Zone',
      secondaryText: 'Developer settings',
    },
    locale: {
      primaryText: 'Currency',
      secondaryText: 'Set your preferred currency',
    },
  },
  tokenDetails: {
    bridgeToEVM: 'Bridge to EVM',
    bridgeToICP: 'Bridge to ICP',
    withdrawFromOdin: 'Withdraw from odin.fun',
    depositToOdin: 'Deposit to Odin',
    today: 'Today',
    yesterday: 'Yesterday',
    description: 'Description',
    lastTransactions: 'Last Transactions',
    utxos: 'Utxos',
  },
  transactionHistory: {
    failed: 'Failed',
    empty: 'No transactions',
    emptyMessage:
      'Use your plug wallet - send, swap, convert tokens - and your activity will appear here',
    searchPlaceholder: 'Search by token',
    transactionsTab: 'Transactions',
    swapsTab: 'Swaps',
    convertsTab: 'Converts',
    details: {
      transactionId: 'Transaction ID',
      date: 'Date',
      time: 'Time',
      from: 'From',
      to: 'To',
      fee: 'Fee',
      memo: 'Memo',
      viewDetails: 'View on explorer',
    },
    filter: 'Filter Transactions',
    filters: {
      Transfer: '💸 Transfer',
      Approve: '✅ Approve',
      Burn: '🔥 Burn',
      Mint: '☘️ Mint',
    },
    transactionKinds: {
      Transfer: {
        send: 'Sent',
        receive: 'Received',
      },
      Approve: 'Approved',
      Burn: 'Burned',
      Mint: 'Minted',
    },
    pending: 'Pending',
  },
  approveTransaction: {
    icrc25_request_permissions: {
      title: 'Connect',
      description:
        'Confirming will allow this site to perform the following actions for the selected account.',
    },
    icrc49_call_canister: {
      title: 'Wants to authorize request',
      description: '',
    },
    icrc49_call_canister_compatibility: {
      title: 'Wants to authorize request',
      description: '',
    },
    icrc34_delegation: {
      title: 'Create Delegation',
      description:
        'Confirming will create delegation (this will allow dApp to call canister without confirmations from Plug)',
    },
    icrc57_get_session_delegation: {
      title: 'Create Session Delegation',
      description:
        'Confirming will allow this site to perform calls on your account behalf for the selected account.',
    },
    request_transfer: {
      title: 'Approve transfer',
      description: 'Confirming will authorize token transfer from the selected account.',
    },
    request_burn_xtc: {
      title: '🔥 Burn XTC',
      description: 'Confirming will authorize cycle transfer to a canister',
    },
    personal_sign: {
      title: 'Message to sign: ',
      additionalInformation: 'Additional Information: ',
      gasInfo: 'Signing this message does not cost any gas or initiate atransaction.',
      warning: 'Make sure you trust the site requesting this signature.',
    },
  },
  transferEth: {
    loading: 'Loading...',
    warning: 'Unable to verify contract details. Proceed at your own risks',
    gasWarning: 'Unable to estimate gas. Proceed at your own risks',
    info: 'Info',
    params: {
      title: 'Parameters',
      transferAmount: 'Transfer Amount',
      token: 'Token',
      receiver: 'Receiver',
      sender: 'Sender',
      function: 'Function',
      functionType: 'Function Type',
      hexData: 'Hex Data',
    },
  },
  authorizationRequest: {
    icrc49_call_canister: 'Call canisters',
    icrc49_call_canister_compatibility: 'Call canisters (Legacy)',
    icrc34_delegation: 'Get delegation',
    icrc27_accounts: 'Get accounts',
    globalDelegationWarningTitle: 'Global Delegation permission request',
    readMore: 'Click to read more',
    globalDelegationWarning:
      'By granting global delegation to token canisters dApp will have full control over your funds on target token canister',
    eth_accounts: 'Access your Ethereum addresses and suggest transactions',
  },
  importWallet: {
    title: 'Import Wallet',
    description: 'Please enter your 12 or 24 word secret recovery phrase',
    placeholder: 'Enter 12 or 24 word secret recovery phrase',
    new: {
      title: 'Create new Wallet',
      description: 'This will create new subaccount wallet from original seed phrase',
    },
    privateKey: {
      title: 'Import Private Key',
      description: 'Add an existing wallet with previously saved Private Key ',
    },
    stoic: {
      title: 'Import from Stoic seed phrase',
      description: 'You can import individual Stoic account by entering old seedphrase',
    },
    error: 'Wallet import error',
    invalidSeed: 'Your provided seed phrase is invalid',
  },
  walletDetailsPrompt: {
    nameNewWallet: 'Name new wallet',
    updateWalletAppearance: 'Update Wallet Appearance',
    walletNamePlaceholder: 'Wallet Name',
    createWallet: 'Create Wallet',
    updateWallet: 'Update Wallet',
  },
  depositCrypto: {
    principalId: 'Principal ID',
    principalIdDescription:
      "Use when receiving from Plug accounts & users, or other apps that support sending directly to Principal ID's",
    accountId: 'Account ID',
    accountIdDescription:
      "Use when receiving from exchanges, or other apps that only support sending to Account ID's",
    buyCrypto: 'Buy Crypto',
    buyCryptoDescription: 'You can easily buy ICP, ETH & BTC with our fiat on-ramp provider',
  },
  mintBtc: {
    ckbtcTitle: 'Use native BTC to mint ckBTC',
    ckbtcDescription:
      'Chain-key BTC (ckBTC) is an ICRC-1-compliant token that is backed 1:1 by bitcoin held 100% on chain',
    directPurchase: 'Direct purchase',
    onrampDescription: 'Use fiat on-ramp providers to deposit BTC and mint ckBTC',
    confirmationDescription: 'Mainnet ckBTC requires 12 confirmations',
    btcTransactions: 'BTC transactions',
    updateBalance: 'update ckBTC balance',
    buy: 'Buy Bitcoin',
  },
  mintCk: {
    title: 'Convert to Chain-Key',
    errors: {
      notEnough: 'Not enough {{token}}',
      notEnoughForGas: 'Not enough {{token}} for gas',
      noAmount: 'Please enter amount',
      fetchingGas: 'Fetching gas fee',
      noGasFee: 'No gas fee available',
      tokenNotFound: 'Token not found',
    },
    inputPlaceholder: 'Enter amount',
    gasFee: 'Gas fee',
    delay: 'Delay',
    delayTime: 'Up to 20 minutes',
    review: 'Review mint',
    failed: 'Mint failed',
    receiveAmount: 'Receive amount',
    mint: 'Mint',
    unmint: 'Unmint',
    mintFailed: 'Failed to mint',
    unmintFailed: 'Failed to unmint',
    mintFailedDescription: 'Please try again and/or contact Plug support team 😔',
    delayWarning: 'It might take up to 2 minutes to complete. Please do not close the window',
    noData: 'Required data not present',
    updateBalance: 'Update ckBTC balance',
    ckBtcBalance: 'ckBTC balance',
    titleAbout: 'What are CK tokens?',
    about:
      'Chain-Key (CK) tokens are created using ICP’s cryptographic protocols, enabling secure cross-chain use without intermediaries. Each CK token is backed 1:1 by its original asset, held entirely onchain by a smart contract.',
  },
  onesec: {
    title: 'Bridge with OneSec',
    fromIcp: 'From ICP',
    toIcp: 'to ICP',
    slippage: 'Slippage',
    receiveAmount: 'You Receive',
    titleAbout: 'How does it work?',
    about: `ODIN.FUN is the fastest way to trade memecoins on Bitcoin. ODIN lets you deposit/withdraw ckBTC and swap tokens instantly.
    Once you deposit ckBTC into ODIN.FUN, you can trade runes both on Plug and ODIN.FUN.`,
    fee: 'Fee',
    ethBalance: 'ETH balance',
    success: 'Conversion successful',
    delay: 'Delay',
    bridgeDelay: 'up to 2 minutes',
    reviewBridge: 'Review bridge',
    delayWarning: 'Do not close the window, it might take up to 2 minutes',
    gasFee: 'Gas fee',
    commision: 'Commision',
    toChain: 'To Chain',
    bridgeHistory: 'Bridge History',
    errors: {
      notEnoughForGas: 'Not enough {{token}} for gas',
      fetchingGas: 'Fetching gas fee',
      notEnough: 'Not enough {{token}}',
      noAmount: 'Please enter amount',
      amountTooSmall: 'Minimum bridge amount is {{minAmount}} {{token}}',
      amountTooBig: 'Maximum bridge amount is {{maxAmount}} {{token}}',
      notEnoughTokenForFee: 'Not enough {{token}} to cover transaction fee',
      bridgeFailed: 'Failed to bridge',
      bridgeFailedDescription: 'Please try again and/or contact Plug support team 😔: {{error}}',
    },
  },
  keyRevealAcceptance: {
    doNotShare: 'Never share you seed phrase or enter it into any apps',
    hide: 'Make sure nobody can see your screen when viewing your seed phrase',
    access: 'Anyone with your seed phrase will have full access to your wallet',
    support: 'Plug support will NEVER ask for your seed phrase',
    passwordTitle: 'Enter your Plug password',
    passwordDescription: 'Please enter your current password in order to proceed',
    beforeWeProceed: 'Before we proceed',
    revealSeedPhrase: 'Reveal seed phrase',
    downloadPem: 'Download PEM',
    pemDownloadAlert: 'On rarest ocassions should you download your PEM private key',
    accessPem: 'Anyone with your PEM private key will have full access to your wallet',
    pemSupport: 'Plug support will NEVER ask for your private key',
    unencryptedPem: 'Make sure you store downloaded file in a secure location as it is UNENCRYPTED',
  },
  connectedApps: {
    emptyTitle: 'No connections',
    emptyDescription:
      'Start by connecting your plug wallet to dApps, active connections will appear here',
  },
  deposit: {
    addressCopied: 'Address copied',
  },
  discover: {
    tabs: {
      home: {
        top5Tokens: 'Top 5 Tokens',
        snsTokens: 'SNS tokens',
        volume: '24h Volume',
        banners: {
          btc: {
            title: 'Mint ckBTC',
            description: 'Unleash the power of Bitcoin',
          },
          eth: {
            title: 'Mint ckETH',
            description: 'Unleash the power of Ethereum',
          },
          usdc: {
            title: 'Mint ckUSDC',
            description: 'Unleash the power of USDC',
          },
        },
      },
      learn: {
        addTokenToPlug: 'Add token to Plug',
        addNftCollection: 'Add NFT Collection',
        documentation: {
          title: 'Plug',
          category: 'Documentation',
          description: 'Use Plug in your dApp',
        },
        nfts: {
          title: 'NFTs',
          category: 'Documentation',
          description: 'Add collection to Plug',
        },
        security: {
          title: 'Security',
          category: 'Tips',
          description: 'How to keep your account secure',
        },
        grant: {
          title: 'Funding',
          category: 'Tips',
          description: 'Explore Dfinity Grant program',
        },
      },
      nfts: {
        title: 'NFTs',
        volume: 'Volume',
        past24h: 'Past 24h',
        allTime: 'All Time',
      },
    },
  },
  seedBackup: {
    copied: 'Seed phrase copied',
    title: 'Backup seed phrase',
    description: 'Below is the seed phrase for your new wallet, write it down',
  },
  unlock: {
    title: 'Unlock',
    moreOptions: 'Unable to access your account? Try restoring',
    logoutWarning: {
      title: 'Warning!',
      description:
        'By continuing you will be logged out and all your settings will be reset to defaults',
      confirm: 'I understand',
      cancel: 'Take me back',
    },
  },
  home: {
    copyDescription: 'Copy account id for sending from exchanges and principal id for ICP network',
    copyAddress: 'Copy Plug Address',
    selectInterval: '📅 Select interval',
    tokenListButtons: {
      manage: 'Manage',
      findTokens: 'Sync',
    },
  },
  importPrivateKey: {
    import: 'Import',
    alreadyExists: 'This principal already exists',
    dropHere: 'Drop files here',
    dragAndDrop: "Drag 'n' drop or click to select your private key (.pem file)",
  },
  exchangeRow: {
    converted: 'Converted',
    swapped: 'Swapped',
  },
  newNetwork: {
    name: {
      title: 'Name',
      placeholder: 'Enter network name',
    },
    host: {
      title: 'Host URL',
      placeholder: 'http://127.0.0.1:5000',
    },
    create: 'Create new network',
    update: 'Update Network',
  },
  ethPermission: {
    ethAccounts: 'Access your Ethereum addresses and suggest transactions',
    notSupported: 'Currently not supported',
  },
  stake: {
    title: 'Staking',
    failedToLoadData: 'Failed to load data, please try again later 😔',
    noAmount: 'Please enter amount',
    depositTooSmall: 'Minimum deposit amount is {{minDeposit}} ICP',
    withdrawTooSmall: 'Minimum withdraw amount is {{minWithdraw}} nICP',
    notEnough: 'Not enough {{tokenSymbol}}',
    stakeIcp: 'Stake ICP',
    unstakeNicp: 'Unstake nICP',
    exchangeRate: 'Exchange Rate',
    receiveAmount: 'You Receive',
    futureReward: 'Future Airdrop',
    success: 'Conversion successful',
    chooseUnstakeMode: 'Please choose unstake mode',
    noSwapQuotesAvailable: 'No swap offers available',
    titleAbout: 'What is nICP?',
    about: `nICP is a token representing ICP locked in a 6-month neuron. You can benefit from the yield generated by the neuron while still having liquid tokens.`,
    unstake: {
      immediate: {
        short: 'Immediately',
        title: 'Unstake immediately',
        description: 'Swap nICP for ICP immediately using most profitable swap provider',
      },
      delayed: {
        short: 'Delayed',
        title: 'Unstake after 6 months',
        description:
          'ICP will be sent to your wallet as soon as the 6 months dissolve delay has elapsed',
      },
      receive: 'Receive',
      swapUnavailable: 'Swap unavailable',
      noSwapOffers: 'No swap offers available currently',
    },
    review: {
      title: {
        stake: 'Staking review',
        unstake: 'Review unstaking',
      },
      stake: 'Stake',
      unstake: 'Unstake',
      unstakeMode: 'Mode',
      swapProvider: 'Swap Provider',
      fee: 'Fee',
      feeAmount: `{{fee}}% + transaction fees`,
    },
    error: {
      title: 'Error occurred 😔',
      description: 'Something unexpected happened, please try again later',
    },
  },
  importWalletStoic: {
    seedPhrasePlaceholder: 'Place your stoic seed phrase here',
    subbaccountWarning:
      'Note that due to the fact, that Plug does not support subaccounts and all our accounts have seperate principal ID, currently this will only import you main Stoic identity.',
    seedPhraseInfo: "Plug won't backup this seed phrase, but just generate the identity",
    import: 'IMPORT',
  },
  contactForm: {
    edit: 'Edit Contact',
    add: 'Add Contact',
    name: 'Name',
    address: 'Address',
    delete: 'Delete',
    save: 'Save',
  },
  llmChat: {
    inputPlaceholder: 'Type your question...',
    failedAuthMessage: `#### I've failed to authenticate you 🥸

Please try reloading the page or try again later!

If the issue persists, please contact our support team 🙋

You can find our support here - https://support.plugwallet.ooo`,
  },
  defi: {
    title: 'DeFi Hub',
    stake: {
      title: 'Stake',
      description: 'Earn rewards by staking ICP',
    },
    onesec: {
      title: 'Bridge to EVM',
      description: 'ICP → EVM asset bridge',
    },
    borrow: {
      title: 'Borrow/Lend',
      description: 'Coming soon',
    },
    topup: {
      title: 'Cycle Top Up',
      description: 'Mint cycles and create rules',
    },
    odin: {
      title: 'Bridge to Odin',
      description: 'Trade BTC fast on Odin.fun',
      deposit: 'Deposit',
      withdraw: 'Withdraw',
      slippage: 'Slippage',
      receiveAmount: 'You Receive',
      titleAbout: 'How does it work?',
      about: `ODIN.FUN is the fastest way to trade memecoins on Bitcoin. ODIN lets you deposit/withdraw ckBTC and swap tokens instantly.
      Once you deposit ckBTC into ODIN.FUN, you can trade runes both on Plug and ODIN.FUN.`,
      fee: 'Fee',
      success: 'Conversion successful',
      errors: {
        depositTooSmall: 'Minimum deposit amount is {{minAmount}} ckBTC',
        withdrawTooSmall: 'Minimum withdraw amount is {{minAmount}} Odin BTC',
        notEnoughTokenForFee: 'Not enough {{token}} to cover transaction fee',
        depositFailed: 'Failed to deposit',
        withdrawFailed: 'Failed to withdraw',
        bridgeFailedDescription: 'Please try again and/or contact Plug support team 😔',
      },
    },
    mint: {
      title: 'Mint CK',
      description: 'Mint Chain-Key tokens',
    },
  },
  topup: {
    title: 'Top-Up',
    tcyclesBalance: 'TCYCLES Balance',
    plugBalance: 'Plug Balance',
    approved: 'Approved',
    topupCanister: '⛽️ Instant top-up',
    topupHistory: 'Top Up history',
    savedCanisters: 'Saved Canisters',
    noCanisters: 'No Canisters Added',
    noCanistersDescription: 'Add canister to manage their cycles and auto top up rules',
    addCycles: '⛽️ Add cycles',
    modes: {
      mint: '🍀 Mint cycles from ICP',
      approve: ' ✅ Approve cycles for auto top up',
    },
    deleteWarning: {
      title: 'Remove canister',
      description:
        'Are you sure you want to remove canister (you can always add it back again later)',
    },
    canisterForm: {
      canisterId: 'Canister ID',
      name: 'Name',
      autoTopup: 'Enable Auto Top-Up',
      topupAmount: 'Amount',
      topupThreshold: 'Threshold',
      topupMode: 'Top-up mode',
      sns: 'SNS project',
    },
    saveError: {
      InvalidInput: 'Invalid Input',
      NotAllowed: 'Action not allowed',
      Duplicate: 'Canister already exists',
      NotBlackholed: 'Blackhole is not controller of this canister',
      NotFound: 'Not Found',
      General: 'Unknown error',
    },
    canisterCard: {
      topUp: 'Top-Up',
      cyclesLeft: 'Cycles left: {{cycles}}',
      autoTopupOff: 'Auto top up is turned off',
    },
    Manual: {
      title: 'Manual Top-Up',
      description:
        'You top-up canister manually from Plug Wallet, balance is available only if Plug wallet principal is controller of the canister',
    },
    SNS: {
      title: 'SNS Canister',
      description:
        'You can see canister balance, top-up automatically and manually. For automatic balance check you need to select SNS project entered canister belongs to',
    },
    Blackhole: {
      title: 'Blackhole',
      description:
        'Blackhole canister (e3mmv-5qaaa-aaaah-aadma-cai) is controller of your canister. This allows Plug to check balances and perform automatic top-up',
    },
    notEnoughBalance:
      'Last auto top-up was not successfull, please check TCYCLES balance and approve amount are sufficient',
    types: {
      SNS: '🤖 SNS - Automatic Top-up',
      Blackhole: '🤖 Blackhole - Automatic Top-up',
      Manual: '⛽️ Manual Top-up',
      Unknown: '❓ Unknown',
    },
  },
  topupHistory: {
    empty: 'No top-up history found',
  },
  addresses: {
    icpPrincipal: 'Principal ID',
    icpAccount: 'Account ID',
    btcAddress: 'BTC Address',
    ethAddress: 'ETH Address + L2s',
    solAddress: 'SOL Address',
    odinAddress: 'Odin Address',
  },
  chains: {
    select: '🔗 Select Chain',
    long: {
      all: 'Chain Fusion (all)',
      icp: 'Internet Computer',
      eth: 'Ethereum',
      btc: 'Bitcoin',
      sol: 'Solana',
      odin: 'Odin',
      arb: 'Arbitrum',
      base: 'Base',
    },
    short: {
      all: 'All',
      icp: 'ICP',
      eth: 'ETH',
      btc: 'BTC',
      sol: 'SOL',
      odin: 'Odin',
      arb: 'ARB',
      base: 'BASE',
    },
  },
}
